if (!customElements.get('diffusers-carousel')) {
  window.__airmPairs = window.__airmPairs || {};

  class DiffusersCarousel extends HTMLElement {
    constructor() {
      super();
      this._boundDesignModeHandler = null;
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.pairId = this.dataset.pairId;
      this.loop = this.dataset.loop === 'true';
      this.autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 0;

      this.swiperEl = this.querySelector('.swiper');
      this.prevEls = this.querySelectorAll('.diffusers-carousel__nav-prev');
      this.nextEls = this.querySelectorAll('.diffusers-carousel__nav-next');
      this.counterCurrentEl = this.querySelector('.diffusers-carousel__counter-current');
      this.counterTotalEl = this.querySelector('.diffusers-carousel__counter-total');

      if (!this.swiperEl) return;

      if (this.pairId) {
        if (window.__airmPairs[this.pairId] && window.__airmPairs[this.pairId] !== this) {
          if (window.Shopify && window.Shopify.designMode) {
            console.warn(`[diffusers-carousel] duplicate pair_id "${this.pairId}" on page.`);
          }
        }
        window.__airmPairs[this.pairId] = this;
      }

      this._initSlider();
      this._bindNavLinks();

      if (window.Shopify && window.Shopify.designMode) {
        this._boundDesignModeHandler = this._onBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this._boundDesignModeHandler);
      }

      this._tryDeepLink();
    }

    disconnectedCallback() {
      if (this.pairId && window.__airmPairs[this.pairId] === this) {
        delete window.__airmPairs[this.pairId];
      }
      if (this._boundDesignModeHandler) {
        document.removeEventListener('shopify:block:select', this._boundDesignModeHandler);
        this._boundDesignModeHandler = null;
      }
      if (this.sliderInstance && this.sliderInstance.slider) {
        this.sliderInstance.slider.destroy(true, true);
      }
      this.sliderInstance = null;
    }

    _initSlider() {
      const options = {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        threshold: 2,
        grabCursor: true,
        allowTouchMove: true,
        loop: this.loop,
        navigation: {
          nextEl: Array.from(this.nextEls),
          prevEl: Array.from(this.prevEls),
        },
        on: {
          init: (swiper) => this._updateCounter(swiper),
          slideChange: (swiper) => this._updateCounter(swiper),
        },
      };

      const modules = [];
      if (this.autoplayDelay > 0 && window.FoxTheme && window.FoxTheme.Swiper && window.FoxTheme.Swiper.Autoplay) {
        modules.push(window.FoxTheme.Swiper.Autoplay);
        options.autoplay = {
          delay: this.autoplayDelay,
          disableOnInteraction: false,
        };
      }

      this.sliderInstance = new window.FoxTheme.Carousel(this.swiperEl, options, modules);
      this.sliderInstance.init();
    }

    _bindNavLinks() {
      // No-op: Swiper handles navigation via the options.navigation config.
    }

    _realSlides() {
      return Array.from(this.swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
    }

    _updateCounter(swiper) {
      const realSlides = this._realSlides();
      const total = realSlides.length;
      const current = (swiper && typeof swiper.realIndex === 'number' ? swiper.realIndex : 0) + 1;
      if (this.counterTotalEl) this.counterTotalEl.textContent = String(total);
      if (this.counterCurrentEl) this.counterCurrentEl.textContent = String(Math.min(current, total));
    }

    goToSlideKey(slideKey) {
      if (!this.sliderInstance || !this.sliderInstance.slider) return;
      const realSlides = this._realSlides();
      const idx = realSlides.findIndex((s) => s.dataset.slideKey === slideKey);
      if (idx < 0) {
        this._scrollIntoView();
        return;
      }
      this._scrollIntoView();
      if (this.loop) {
        this.sliderInstance.slider.slideToLoop(idx);
      } else {
        this.sliderInstance.slider.slideTo(idx);
      }
    }

    _scrollIntoView() {
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    _onBlockSelect(event) {
      if (event.detail.sectionId !== this.sectionId) return;
      const { target } = event;
      const index = Number(target.dataset.index);
      if (!this.sliderInstance || !this.sliderInstance.slider || Number.isNaN(index)) return;
      if (this.loop) {
        this.sliderInstance.slider.slideToLoop(index);
      } else {
        this.sliderInstance.slider.slideTo(index);
      }
    }

    _tryDeepLink() {
      const raw = (window.location.hash || '').replace(/^#/, '');
      if (!raw) return;
      const params = new URLSearchParams(raw);
      const pairId = params.get('pair');
      const slideKey = params.get('slide');
      if (!pairId || !slideKey || pairId !== this.pairId) return;
      requestAnimationFrame(() => this.goToSlideKey(slideKey));
    }
  }

  customElements.define('diffusers-carousel', DiffusersCarousel);
}
